<template>
  <div>
    <div class="offline-indicator">
      <p>Your device has lost internet connectivity</p>
    </div>

    <div class="offline-order-counter" v-if="cart.length > 0 && !online">{{cart.length}}</div>
  </div>
</template>

<script>
export default {
  name: 'offline',
  data: function () {
    return {
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : [],
      online: true
    }
  },
  mounted: function () {
    var that = this
    setInterval(function () {
      if (navigator.onLine) {
        that.online = true
      } else {
        that.online = false
      }
    }, 2000)
  }
}
</script>

<style scoped>
.offline-indicator {
  background:#F8ECAD;
  color:#A7994F;
  padding:10px 10px 3px 10px;
  position:fixed;
  bottom:0;
  text-align:center;
  width:100%;
  display:none;
}

.offline-order-counter {
  position:fixed;
  bottom:0;
  right:10px;
  padding:20px;
  background:#FFF;
  z-index:99999999999;
  border:1px solid #000;
}
</style>
